module.exports = __webpack_public_path__ + "static/media/07_plantilla_rec_combo_simple_cf_stills_tetra_1l_cepita_naranja.54d963d5.png";